<script setup lang="ts">
import TheNav from './components/TheNav.vue'
import HeroSection from './components/HeroSection.vue'
import PainPointsSection from './components/PainPointsSection.vue'
import WhatSection from './components/WhatSection.vue'
import HowSection from './components/HowSection.vue'
import ComponentsSection from './components/ComponentsSection.vue'
import GetStartedSection from './components/GetStartedSection.vue'
import DownloadSection from './components/DownloadSection.vue'
import FooterSection from './components/FooterSection.vue'
</script>

<template>
  <TheNav />
  <main>
    <HeroSection />
    <PainPointsSection />
    <WhatSection />
    <HowSection />
    <ComponentsSection />
    <GetStartedSection />
    <DownloadSection />
  </main>
  <FooterSection />
</template>
